import { render } from "./appointmentby-doc.vue?vue&type=template&id=0645df42&scoped=true"
import script from "./appointmentby-doc.vue?vue&type=script&lang=js"
export * from "./appointmentby-doc.vue?vue&type=script&lang=js"

import "./appointmentby-doc.vue?vue&type=style&index=0&id=0645df42&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0645df42"]])

export default __exports__